export const host = 'https://api-beta.airgloss.com';
